// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
  width: 100%;
  height: 100%;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 15px;
  margin-top: 15px;
}

#search-container {
  top: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.search-container-input {
  top: 30px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 90%;
}

.map-toggle {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 5px;
}

.map-toggle-container {
  height: 48px;
  margin: 4px 0;
  background: white;
}

.mode-icon {
  padding: 10px;
  height: 40px;
  width: 40px;
}

.mode-icon {
  background: #f8f8f8;
  color: var(--ion-color-black);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  color: #f8f8f8;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}
.loading-container ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.block-venues {
  background: #f8f8f8;
}

.full-height {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/maps/components/map-venue/map-venue.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AACA;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAGF;AADE;EACE,WAAA;AAGJ;;AAAA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAGF;;AADA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAIF;;AADA;EACE,oBAAA;AAIF;;AADA;EACE,UAAA;AAIF;;AAFA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AAKF;;AAHA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAMF;;AAHA;EACE,aAAA;EACA,YAAA;EACA,WAAA;AAMF;;AAHA;EACE,mBAAA;EACA,6BAAA;EACA,uBAAA;AAMF;;AAHA;EACE,oCAAA;EACA,cAAA;EACA,uBAAA;AAMF;;AAHA;EACE,YAAA;AAMF;;AAHA;EAKE,cAAA;EACA,YAAA;AAEF;AAPE;EACE,gBAAA;AASJ;AAHE;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AAKJ;;AAFA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAKF;AAJE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAMJ;;AAFA;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAKF;AAHE;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAKJ;AAFE;EACE,eAAA;AAIJ;AADE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAGJ;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AAIA;EACE,mBAAA;AADF;;AAGA;EACE,YAAA;AAAF","sourcesContent":["#map {\n  width: 100%;\n  height: 100%;\n}\n\n.search-bar {\n  border-radius: 4px;\n  line-height: 1.6;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n}\n.title {\n  font-family: AppFontBold, sans-serif;\n  font-size: 14px;\n  text-transform: uppercase;\n  margin-left: 15px;\n  margin-top: 15px;\n}\n#search-container {\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  position: absolute;\n  padding: 0px;\n  background: white;\n\n  app-venue-suggestion {\n    width: 100%;\n  }\n}\n.search-container-input {\n  top: 30px;\n  left: 0px;\n  right: 0px;\n  position: absolute;\n  padding: 0px;\n  background: white;\n}\n.slides-container {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n}\n\n.swiper-slide {\n  align-self: flex-end;\n}\n\napp-venue-suggestion {\n  width: 90%;\n}\n.map-toggle {\n  display: flex;\n  justify-content: space-between !important;\n  align-items: center;\n  padding: 5px;\n}\n.map-toggle-container {\n  height: 48px;\n  margin: 4px 0;\n  background: white;\n}\n\n.mode-icon {\n  padding: 10px;\n  height: 40px;\n  width: 40px;\n}\n\n.mode-icon {\n  background: #f8f8f8;\n  color: var(--ion-color-black);\n  transition: 0.3s linear;\n}\n\n.mode-icon.selected {\n  background: var(--ion-color-primary);\n  color: #f8f8f8;\n  transition: 0.3s linear;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.sidebar {\n  app-venue-suggestion {\n    margin: 5px auto;\n  }\n\n  overflow: auto;\n  height: 100%;\n\n  .title {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.loading-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 10;\n  background: black;\n  opacity: 0.5;\n  ion-spinner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.hint {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 14px;\n  background: white;\n\n  p {\n    font-size: 12px;\n    color: black;\n    margin: 0;\n    padding: 0 8px;\n  }\n\n  span {\n    font-size: 14px;\n  }\n\n  ion-icon {\n    height: 44px;\n    width: 44px;\n    place-self: center;\n  }\n}\n\n.center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n// .wrapper {\n//   width: 100vw;\n//   height: calc(100vh - 60px)\n// }\n.block-venues {\n  background: #f8f8f8;\n}\n.full-height {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
